/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EmailRed = ({
  className,
  style: styleFromProps,
  color = '#938BB7',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <path
        d="M18.3334 5.17134C18.2607 4.66127 18.0164 4.19542 17.6447 3.85823C17.2731 3.52104 16.7986 3.33484 16.3075 3.33337H3.69258C3.20141 3.33484 2.72698 3.52104 2.35532 3.85823C1.98366 4.19542 1.73935 4.66127 1.66669 5.17134L10 10.8334L18.3334 5.17134Z"
        fill="url(#paint0_linear_10131_130290)"
      />
      <path
        d="M10.3017 11.7193C10.2118 11.7758 10.1071 11.8058 10 11.8058C9.89299 11.8058 9.78823 11.7758 9.69835 11.7193L1.66669 6.66717V14.6742C1.66728 15.2024 1.88339 15.7089 2.26761 16.0824C2.65182 16.456 3.17277 16.6661 3.71613 16.6666H16.2839C16.8273 16.6661 17.3482 16.456 17.7324 16.0824C18.1167 15.7089 18.3328 15.2024 18.3334 14.6742V6.66663L10.3017 11.7193Z"
        fill="url(#paint1_linear_10131_130290)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10131_130290"
          x1="4.16669"
          y1="9.6615"
          x2="9.6012"
          y2="-0.742414"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#F75C51" />
          <stop offset="1" stopColor="#D22B24" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10131_130290"
          x1="4.16669"
          y1="15.1041"
          x2="12.4474"
          y2="3.21455"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#F75C51" />
          <stop offset="1" stopColor="#D22B24" />
        </linearGradient>
      </defs>
    </svg>
  );
};
